import {Alert} from '@mui/material';
import {useTranslation} from 'react-i18next';

export default function ErrorView() {
  const {t} = useTranslation('app');
  return <Alert severity="error">{t('app:appError')}</Alert>;
}
